export default class TopView {
    constructor() {
        this.main = document.querySelector('.js-main');
    }
}
